export default __webpack_public_path__ + "static/media/chatbot-ola.002a973b.svg";